import axios from "axios";
import authHeader from "./auth-header";
import {API_URL} from "./api-uri";

const getAgencies = () => {
  return axios
  .get(API_URL + "Agencies", { headers: authHeader() })
  .then((response) => {
    return response.data;
  });
};

const upsertAgency = (agency) => {
  return axios
  .put(API_URL + "Agencies/UpsertAgency/" + agency.id, agency)
  .then((response) => {
    return response.data;
  });
};

const deleteAgency = (agency_id) => {
  return axios.delete(API_URL + "Agencies/" + agency_id).then(() => { return });
};

export default {
    getAgencies,
    upsertAgency,
    deleteAgency
};